import { Tag } from 'antd'
import { toNumber } from 'lodash'

import { queryTradeSessionApplyListApi } from '@eastcoal/api/trade/applyOperation/queryTradeSessionApplyList'

import { ButtonGroup } from '@eastcoal/common/components/ButtonGroup'
import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { pick } from '@eastcoal/common/utils/object'

import {
  DepositStatus,
  DepositStatusColorMap,
  DepositStatusTextMap
} from '@eastcoal/shared/enums/DepositStatus'

import { ApplyType, ApplyTypeTextMap } from '../../../../enums/ApplyType'
import { AuctionOperationPageStatus } from '../../../../enums/AuctionOperationPageStatus'
import { useAuctionListStore } from '../../../../Store/hooks/useStore'
import { ApplyAuditButton } from '../components/AuditButton'
import { ApplyCertificationsCheckButton } from '../components/CertificationsCheckButton'
import { ApplyEnableButton } from '../components/EnableButton'
import { ApplyForbidButton } from '../components/ForbidButton'
import { ApplyListStatusRender } from '../components/ListStatusRender'
import { ApplyWithdrawButton } from '../components/WithdrawButton'
import { useBidMemberListModalStore } from '../Store/hooks/useContext'

import { BidMemberListApplyTableProps } from './interface'

const columns: BidMemberListApplyTableProps['columns'] = [
  {
    dataIndex: 'memberName',
    title: '会员名称',
    width: 300,
    align: 'center'
  },
  {
    dataIndex: 'profileName',
    title: '业务受托人',
    align: 'center'
  },
  {
    dataIndex: 'phone',
    title: '联系方式',
    align: 'center'
  },
  {
    dataIndex: 'applyType',
    title: '参与方式',
    align: 'center',
    render(value) {
      return ApplyTypeTextMap[value as ApplyType]
    }
  },
  {
    dataIndex: 'buyCount',
    title: '购买份数',
    valueType: 'digit',
    align: 'right'
  },
  {
    dataIndex: 'createdTime',
    title: '申请时间',
    align: 'center'
  },
  {
    dataIndex: 'status',
    title: '报名状态',
    align: 'center',
    render(_, record) {
      return <ApplyListStatusRender record={record} />
    }
  },
  {
    dataIndex: 'depositStatus',
    title: '保证金状态',
    align: 'center',
    render(_, { depositStatus = DepositStatus.NOT_PAY }) {
      return (
        <Tag color={DepositStatusColorMap[depositStatus]} variant='filled'>
          {DepositStatusTextMap[depositStatus]}
        </Tag>
      )
    }
  },
  {
    dataIndex: 'managerName',
    title: '客户经理',
    align: 'center'
  },
  {
    dataIndex: 'action',
    title: '操作',
    align: 'center',
    visible(context) {
      return toNumber(context.status) <= AuctionOperationPageStatus.BIDDING
    },
    render: (_, record, __, context) => {
      if (toNumber(context.status) < AuctionOperationPageStatus.BIDDING) {
        return (
          <ButtonGroup>
            <ApplyWithdrawButton record={record} />
            <ApplyCertificationsCheckButton record={record} />
            <ApplyAuditButton record={record} />
            <ApplyEnableButton record={record} />
            <ApplyForbidButton record={record} />
          </ButtonGroup>
        )
      }
      // 允许竞价开始后还可以审核会员资质
      if (toNumber(context.status) === AuctionOperationPageStatus.BIDDING) {
        return <ApplyAuditButton record={record} />
      }

      return null
    }
  }
]

export const BidMemberListApplyPanel = () => {
  const { tableRef } = useBidMemberListModalStore()

  const { currentAuction, bidMemberListModalVisible } = useAuctionListStore(
    state => pick(state, ['currentAuction', 'bidMemberListModalVisible'])
  )
  const auctionId = currentAuction?.id

  return (
    <RemoteTable
      ref={tableRef}
      api={queryTradeSessionApplyListApi}
      columns={columns}
      context={currentAuction}
      readyRequest={bidMemberListModalVisible && !!auctionId}
      refreshDeps={[bidMemberListModalVisible, auctionId]}
      rowKey='id'
      requestParams={{
        bizId: auctionId
      }}
    />
  )
}
